import { React, useState, useEffect } from "react";
import { useTranslation } from "../contexts/TranslationContext";

export default function ViewMedication(props) {
  const medication = props.medication;
  const [disabled, setDisabled] = useState(true);
  const [editHover, setEditHover] = useState(false);
  const { translate } = useTranslation()
  useEffect(() => {
    if (!props.medication.id) {
      setDisabled(false);
    }
  }, [props]);
  return (
    <div className="mt-4 flex items-center">
      <div className="grid grid-cols-12 text-center text-text-3 font-font-2 font-normal">
        <div className="my-auto flex justify-end">
          <div className="flex flex-col leading-none text-text-1">
            <button
              className="mt-1 -m-1 focus:outline-none"
              onClick={() => {
                props.changePriority("medications", props.index, -1);
              }}
            >
              ⬆
            </button>
            <button
              className="focus:outline-none"
              onClick={() => {
                props.changePriority("medications", props.index, 1);
              }}
            >
              ⬇
            </button>
          </div>
          <div className="mx-2 flex w-8 bg-background-10 text-black font-bold">
            <p className="m-auto">{props.index + 1}</p>
          </div>
        </div>
        <select
          name="medications"
          id="medications"
          style={{
            border: 0,
            WebkitAppearance: "none",
            appearance: "none",
          }}
          value={medication.Tid}
          disabled={disabled}
          className="px-2 py-1 bg-background-6 font-bold"
          onChange={(event) => {
            var proc = [];
            for(var i = 0; i < props.templateMedications.length; i++){
              if(props.templateMedications[i].id === parseInt(event.target.value)){
                proc = props.templateMedications[i];
                break;
              }
            }
            props.setMedication({
              ...medication,
              Tid: proc.id,
              fee: proc.fee,
              brand: proc.brand,
              dosage: proc.dosage,
            });
          }}
        >
          <option value=""></option>
          {props.templateMedications &&
            props.templateMedications.map((proc, i) => {
              return (
                <option
                  key={i}
                  value={proc.id}
                >{`${proc.name}`}</option>
              );
            })}
        </select>
        <input
          type="text"
          className="px-2 py-1 w-full border-r border-background-6 bg-background-7 focus:outline-none"
          value={medication.brand}
          disabled={disabled}
          onChange={(event) => {
            props.setMedication({ ...medication, brand: event.target.value });
          }}
        />
        <input
          type="text"
          className="px-2 py-1 w-full border-r border-background-6 bg-background-7 focus:outline-none"
          value={medication.dosage}
          disabled={disabled}
          onChange={(event) => {
            props.setMedication({ ...medication, dosage: event.target.value });
          }}
        />
        <input
          type="text"
          className="px-2 py-1 w-full border-r border-background-6 bg-background-7 focus:outline-none"
          value={medication.number}
          disabled={disabled}
          onChange={(event) => {
            props.setMedication({ ...medication, number: event.target.value });
          }}
        />
        <input
          type="text"
          className="px-2 py-1 w-full border-r border-background-6 bg-background-7 focus:outline-none"
          value={medication.refill}
          disabled={disabled}
          onChange={(event) => {
            props.setMedication({ ...medication, refill: event.target.value });
          }}
        />
        <input
          type="number"
          className="px-2 py-1 w-full border-r border-background-6 bg-background-7 focus:outline-none"
          value={medication.fee}
          disabled={disabled}
          onChange={(event) => {
            props.setMedication({ ...medication, fee: event.target.value });
          }}
        />
        {(!props?.medication?.rx && (
          <>
            {disabled ? (
              <div
                className="bg-background-7 flex cursor-pointer"
                onMouseOver={() => {
                  setEditHover(true);
                }}
                onMouseOut={() => {
                  setEditHover(false);
                }}
              >
                <svg
                  className="m-auto h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill={editHover ? "#13c3b2" : "#bec4ca"}
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                  />
                </svg>
                <div
                  className={`absolute mt-8 flex flex-col text-sm bg-background-10 text-black ${
                    !editHover && "hidden"
                  }`}
                >
                  <button
                    className="p-1 focus:outline-none"
                    onClick={() => {
                      setDisabled(false);
                    }}
                  >
                    {translate('edit')}
                  </button>
                  <button
                    className="p-1 focus:outline-none"
                    onClick={() => {
                      props.duplicateTreatment(
                        props.medication.id,
                        "medications"
                      );
                    }}
                  >
                    {translate('duplicate')}
                  </button>
                  <button
                    className="p-1 focus:outline-none"
                    onClick={() => {
                      props.deleteTreatment(props.medication.id, "medications", props.index);
                    }}
                  >
                    {translate('delete')}
                  </button>
                </div>
              </div>
            ) : (
              <div className="bg-background-7 flex">
                <button
                  className="m-auto focus:outline-none"
                  onClick={() => {
                    // props.saveTreatment(medication);
                    setDisabled(true);
                  }}
                >
                  <svg
                    className="h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="#13c3b2"
                      d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
                    />
                  </svg>
                </button>
              </div>
            )}
          </>
        )) || <div className="bg-background-7 flex"></div>}
        <div className="bg-background-7 flex">
          <button
            className="mx-auto focus:outline-none"
            onClick={() => {
              if (!medication.id)
                return alert("Please save treatment first");
              props.setModalConsent({tid: medication.id, ...medication.consent});
              props.setShowConsent(true)
            }}
          >
            <svg
              className="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                fill={medication.consent ? "#13c3b2" : "#bec4ca"}
                d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
              />
            </svg>
          </button>
        </div>
        <div className="bg-background-7 flex">
          <button className="mx-auto focus:outline-none">
            <svg
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                fill={props.medication.paymentCompleted ? "#13c3b2" : "#bec4ca"}
                d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
              />
            </svg>
          </button>
        </div>
        <div className="bg-background-7 flex">
          <button className="mx-auto focus:outline-none">
            <svg
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                fill={props.medication.rx ? "#13c3b2" : "#bec4ca"}
                d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
